module.exports = {
      id: "icon-a-arrow-left-usage",
      viewBox: "0 0 10 10",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-a-arrow-left",
      toString: function () {
        return this.url;
      }
    }